import { useMemo } from 'react'
import {
  AssignmentOutlined,
  DescriptionOutlined,
  HomeOutlined,
  Menu,
  PaymentsOutlined,
} from '@mui/icons-material'
import { routes } from '@/router'
import { CreditSidebarCard } from './credit-sidebar-card'
import { NavigationConfig } from './types'

export function useCreditNavigation(): NavigationConfig {
  const items = useMemo(
    () => [
      {
        name: 'Resumo',
        route: routes.credit.index,
        icon: <HomeOutlined />,
      },
      {
        name: 'Solicitações',
        route: routes.credit.applications,
        icon: <AssignmentOutlined />,
      },
      {
        name: 'Parcelas',
        route: routes.credit.installments,
        icon: <PaymentsOutlined />,
      },
      {
        name: 'Contratos',
        route: routes.credit.contracts,
        icon: <DescriptionOutlined />,
      },
    ],
    [],
  )

  const mobileItems = useMemo(
    () => [
      {
        route: routes.credit.index,
        icon: <HomeOutlined sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.credit.installments,
        icon: <PaymentsOutlined sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.credit.contracts,
        icon: <DescriptionOutlined sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.credit.menu,
        icon: <Menu sx={{ fontSize: 28 }} />,
      },
    ],
    [],
  )

  return {
    items,
    menuItems: items.filter((item) => item.route !== routes.credit.index),
    mobileItems,
    sidebarCard: <CreditSidebarCard />,
  }
}
